import { DisputeFormProps } from '@anm/api/modules/stocks';
import YoutubeCopyrightClaimForm from '@anm/components/form/YoutubeCopyrightClaimForm';
import useSwitchState from '@anm/hooks/useSwitchState';
import { FC } from 'react';

import { ClaimResolveText, SecondaryTitle } from './Wrapper';

type CopyrightClaimProps = {
  isPendingSubmit: boolean;
  onSubmit(values: DisputeFormProps): void;
};

const CopyrightClaim: FC<CopyrightClaimProps> = props => {
  const [isDisputeForm, openDisputeForm] = useSwitchState();

  if (!isDisputeForm) {
    return (
      <ClaimResolveText>
        Adding your YouTube ID didn’t help? If after 30 minutes your claim is
        not resolved, <span onClick={openDisputeForm}>click here</span>.
      </ClaimResolveText>
    );
  }

  return (
    <>
      <SecondaryTitle
        level={3}
        title="Dispute a Copyright Claim"
        description="If your YouTube channel ID (see Step 1) is up to date and your claim was not automatically resolved in less than 30 minutes, we can still help you! We can remove 95% of outstanding copyright claims in less than 72 hours by filing a dispute form. Fill out all the information below and click Submit dispute."
      />
      <YoutubeCopyrightClaimForm {...props} />
    </>
  );
};

export default CopyrightClaim;
